import { render, staticRenderFns } from "./ClientesPendientes.vue?vue&type=template&id=a0e2f350&"
import script from "@/Servicios/ClientesPendientes.js?vue&type=script&lang=js&"
export * from "@/Servicios/ClientesPendientes.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports